import React from 'react';
import { X, RotateCcw } from 'lucide-react';

/**
 * ActiveFiltersBar - Displays active filters as removable pills
 * Mimics Cars.com's active filter display
 */
const ActiveFiltersBar = ({ filters, onRemoveFilter, onResetAll }) => {
  // Build array of active filter objects for display
  const activeFilters = [];

  if (filters.make) {
    activeFilters.push({ key: 'make', label: filters.make, value: filters.make });
  }
  if (filters.model) {
    activeFilters.push({ key: 'model', label: filters.model, value: filters.model });
  }
  if (filters.type) {
    activeFilters.push({ key: 'type', label: filters.type, value: filters.type });
  }
  if (filters.location) {
    activeFilters.push({ key: 'location', label: filters.location, value: filters.location });
  }
  if (filters.radius && filters.radius !== '50') {
    activeFilters.push({ key: 'radius', label: `${filters.radius} mi radius`, value: filters.radius });
  }
  if (filters.maxMileage) {
    const mileageLabel = parseInt(filters.maxMileage).toLocaleString();
    activeFilters.push({ key: 'maxMileage', label: `Under ${mileageLabel} mi`, value: filters.maxMileage });
  }
  if (filters.availability === 'today') {
    activeFilters.push({ key: 'availability', label: 'Available Today', value: 'today' });
  } else if (filters.availability === 'week') {
    activeFilters.push({ key: 'availability', label: 'Available This Week', value: 'week' });
  }
  if (filters.verifiedOnly) {
    activeFilters.push({ key: 'verifiedOnly', label: 'Verified Only', value: true });
  }
  if (filters.includeShippable) {
    activeFilters.push({ key: 'includeShippable', label: 'Shippable', value: true });
  }

  // If no active filters, don't render
  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <div className="bg-app-bg-secondary-light dark:bg-app-bg-secondary rounded-2xl border border-app-border-light dark:border-app-border p-4">
      <div className="flex flex-wrap items-center gap-2">
        {/* Active Filter Pills */}
        {activeFilters.map((filter, index) => (
          <button
            key={`${filter.key}-${index}`}
            onClick={() => onRemoveFilter(filter.key)}
            className="inline-flex items-center gap-2 px-3 py-1.5 bg-app-accent/10 hover:bg-app-accent/20 text-app-accent rounded-lg text-sm font-medium transition-all duration-200 group"
          >
            <span>{filter.label}</span>
            <X className="w-4 h-4 group-hover:scale-110 transition-transform" />
          </button>
        ))}

        {/* Reset All Button */}
        <button
          onClick={onResetAll}
          className="inline-flex items-center gap-2 px-3 py-1.5 bg-app-bg-tertiary-light dark:bg-app-bg-tertiary hover:bg-app-error/10 text-app-text-secondary-light dark:text-app-text-secondary hover:text-app-error rounded-lg text-sm font-medium transition-all duration-200"
        >
          <RotateCcw className="w-4 h-4" />
          <span>Reset Filters</span>
        </button>
      </div>
    </div>
  );
};

export default ActiveFiltersBar;
